import { Module, VuexModule, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';
import PriceRequestService from '@/services/PriceRequestService';
import LoadingModule from './LoadingModule';
import { PriceRequest, PriceRequestCountry, PriceRequestEditModel, PriceRequestProductsLookup } from '@/models/PriceRequest';

@Module({
    store,
    dynamic: true,
    name: 'pricerequest',
    namespaced: true,
})
class PriceRequestModule extends VuexModule {
    private prs: PriceRequestService = new PriceRequestService();

    private priceRequest: PriceRequest = this.prs.getRequestProductsModel();
    private priceRequestsLoaded: boolean = false;
    private priceRequestsLookup: PriceRequestProductsLookup = this.prs.getPriceRequestLookupModel();
    private isOpen: boolean = false;
    private countries: PriceRequestCountry[] = [];

    get PRICEREQUEST(): PriceRequest {
        return this.priceRequest;
    }

    get PRICEREQUESTS_LOADED(): boolean {
        return this.priceRequestsLoaded;
    }

    get IS_OPEN(): boolean {
        return this.isOpen;
    }

    get PRICEREQUESTS_LOOKUP(): PriceRequestProductsLookup {
        return this.priceRequestsLookup;
    }

    get COUNTRIES(): PriceRequestCountry[] {
        return this.countries
    }

    @Action({ commit: 'SET_PRICEREQUEST' })
    public async GET_PRICEREQUEST() {
        LoadingModule.SET_LOADING(true);
        return await this.prs.getPriceRequestProducts();
    }

    @Action({ commit: 'SET_PRICEREQUEST' })
    public async ADD_TO_PRICEREQUESTS(args: PriceRequestEditModel) {
        LoadingModule.SET_LOADING(true);
        return await this.prs.addRequestProduct(args);
    }

    @Action({ commit: 'SET_PRICEREQUEST' })
    public async REMOVE_FROM_PRICEREQUESTS(args: PriceRequestEditModel) {
        LoadingModule.SET_LOADING(true);
        return await this.prs.removeRequestProduct(args);
    }

    @Action({ commit: 'SET_COUNTRIES' })
    public async GET_COUNTRIES() {
        LoadingModule.SET_LOADING(true);
        return await this.prs.getCountries();
    }

    @Mutation
    public SET_PRICEREQUEST(payload: PriceRequest) {
        this.priceRequest = payload;
        this.priceRequestsLookup = this.prs.createLookup(payload);
        this.priceRequestsLoaded = true;
        LoadingModule.SET_LOADING(false);
    }

    @Mutation
    public SET_IS_OPEN(args: boolean) {
        this.isOpen = args;
    }

    @Mutation
    public SET_COUNTRIES(payload: PriceRequestCountry[]) {
        this.countries = payload;
        LoadingModule.SET_LOADING(false);
    }
}

export default getModule(PriceRequestModule);